module.exports = __webpack_public_path__ + "static/media/refrels.56aae172.svg";